import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ApiError } from 'src/api/axiosClient/types';
import { Automation } from '../types';
import { AutomationsState } from './types';

const initialState: AutomationsState = {
  loading: {
    getList: false,
    create: false,
    update: false,
    delete: false,
  },
  filter: {
    companyId: '',
    status: 'active,inactive',
    sort: 'name_asc',
    offset: 0,
    limit: 25,
    page: 0,
  },
  list: null,
  error: null,
};

const automationsSlice = createSlice({
  name: 'automations',
  initialState,
  reducers: {
    setLoading: (
      state,
      action: PayloadAction<Partial<Record<keyof AutomationsState['loading'], boolean>>>,
    ) => {
      state.loading = { ...state.loading, ...action.payload };
    },
    setFilter(state, action: PayloadAction<Partial<AutomationsState['filter']>>) {
      state.filter = {
        ...state.filter,
        ...action.payload,
      };
    },
    setList: (
      state,
      action: PayloadAction<{
        items: Automation[];
        count: number;
      }>,
    ) => {
      state.list = action.payload;
    },
    setError: (state, action: PayloadAction<ApiError>) => {
      state.error = action.payload;
    },
    resetList: state => {
      state.filter = initialState.filter;
      state.list = initialState.list;
    },
    resetError: state => {
      state.error = initialState.error;
    },
  },
});

export const { setLoading, setFilter, setList, setError, resetList, resetError } =
  automationsSlice.actions;

export const automationsReducer = automationsSlice.reducer;
